import { ILanguage } from 'src/types/DTO/language/ILanguage';

export const toLanguages = (data: any): ILanguage[] => data?.map((item: any) => toLanguage(item));

export const toLanguage = (item: any): ILanguage => ({
  id: item?.id,
  name: item?.lanName,
  code: item?.lanCode,
  description: item?.lanDes,
});
